import { useFetchSuretyAccount } from "@portal/api/account";
import { FC } from "react";
import { AccountTabProps } from "../../../account/AccountLayout";
import { AccountCompaniesSection } from "./companies/AccountCompaniesSection";
import { AccountHistorySection } from "./history/AccountHistorySection";
import { AccountIndividualsSection } from "./individuals/AccountIndividualsSection";
import { AccountModelSizeSection } from "./model-size/AccountModelSizeSection";
import { AccountSpecialtySection } from "./specialty/AccountSpecialtySection";

type AccountDetailsTabProps = AccountTabProps;

export const AccountDetailsTab: FC<AccountDetailsTabProps> = ({ accountId }) => {
	const { suretyAccount } = useFetchSuretyAccount(accountId);
	const specialtyReadOnly = suretyAccount?.status === "closed";

	return (
		<div
			className="relative flex flex-col w-full pb-[125px]"
			data-testid="agent-account-details-tab"
		>
			<div className="flex flex-col space-y-[40px]">
				<div id="individuals">
					<AccountIndividualsSection accountId={accountId} />
				</div>
				<div id="companies">
					<AccountCompaniesSection accountId={accountId} />
				</div>
				<div id="specialty">
					<AccountSpecialtySection accountId={accountId} readOnly={specialtyReadOnly} />
				</div>
				<div id="history">
					<AccountHistorySection accountId={accountId} />
				</div>
				<AccountModelSizeSection accountId={accountId} />
			</div>
		</div>
	);
};
